/**
 * Homepage header on scroll (header[data-header-float]).
 * At the top the header floats see-through over the hero, just below the announcement bar (which stays put).
 * Once the shopper scrolls down past the header, it slides in fixed to the top as the solid bar (.is-pinned)
 * and stays while they browse. Scrolling back up to the top returns it to see-through.
 * While the shopper is above the end of the full-screen scroll section marked [data-header-clear], the pinned header stays hidden.
 */
const header = document.querySelector('header[data-header-float]');

if (header) {
  const bar = document.querySelector('.ab-bar');
  let ticking = false;

  // Keep the floating header exactly below the announcement bar, whatever its height.
  const place = () => {
    if (!header.classList.contains('is-pinned')) document.documentElement.style.setProperty('--home-header-h', `${header.offsetHeight}px`);
    if (header.classList.contains('is-pinned')) {
      header.style.top = '';
    } else if (bar) {
      header.style.top = `${bar.getBoundingClientRect().bottom + window.scrollY}px`;
    }
  };

  // Hidden while the shopper is between the top of the page and the end of the full-screen scroll section(s) marked [data-header-clear] (Shop by style).
  const beforeStylesEnd = () => [...document.querySelectorAll('[data-header-clear]')].some((section) => section.getBoundingClientRect().bottom > 1);

  const update = () => {
    ticking = false;
    const y = Math.max(0, window.scrollY);
    const barHeight = bar ? bar.offsetHeight : 0;
    const pinned = header.classList.contains('is-pinned');

    if (!pinned && y > barHeight + header.offsetHeight) {
      header.classList.add('is-pinned', 'is-hidden', 'is-instant');
      void header.offsetHeight;
      header.classList.remove('is-instant');
    } else if (pinned && y <= barHeight) {
      header.classList.add('is-instant');
      header.classList.remove('is-pinned', 'is-hidden');
      void header.offsetHeight;
      header.classList.remove('is-instant');
    }
    // Once pinned: stays tucked away until Shop by style has scrolled fully past, then slides in (and tucks away again on the way back up).
    if (header.classList.contains('is-pinned')) {
      header.classList.toggle('is-hidden', beforeStylesEnd());
    }
    header.classList.remove('is-clear');
    place();
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('resize', place, { passive: true });
  update();
}
